<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
      </div>
      <el-steps :active="2" align-center style="border-bottom:1px solid #E9E9E9;padding-bottom:20px;">
        <el-step title="准备充电" :description="rowdata.startTime" />
        <el-step title="开始充电" :description="rowdata.startTime" />
        <el-step title="结束充电" :description="rowdata.endTime" />
        <el-step title="订单支付" :description="rowdata.payTime" />
      </el-steps>
      <div class="orderInfo">
        <div class="orderMoney">
          <div>订单总金额</div>
          <span class="money">{{ getFloat(rowdata.totalMoney) }}</span>
          <span class="col-333">元</span>
        </div>
        <div class="orderMoney">
          <div>订单总优惠</div>
          <span class="money">{{ getFloat(rowdata.discountMoney) }}</span>
          <span class="col-333">元</span>
        </div>
        <div class="orderMoney">
          <div>实收金额</div>
          <span class="money">{{ getFixed2(rowdata.totalMoneyActual) }}</span>
          <span class="col-333">元</span>
        </div>
      </div>
      <div style="width:90%;margin:0 auto;padding-top:26px;padding-top:26px;">
        <SForm ref="formref" :fields="formfields" :data-form="rowdata" label-width="100px" :is-show-btn="false" form-style="width:calc(50% - 10px);display:inline-block" label-position="left" /></div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电信息</span>
      </div>
      <div style="width:90%;margin:0 auto;padding-top:26px;">
        <SForm ref="editformref" :fields="editformfields" :data-form="rowdata" label-width="100px" :is-show-btn="false" form-style="width:calc(50% - 10px);display:inline-block" label-position="left" />
      </div>
    </el-card>
  </div>
</template>

<script>
const token = window.localStorage.getItem('token')
export default {
  components: {},
  data() {
    return {
      // 电桩信息
      rowdata: {},
      formfields: [
        {
          label: '充电单号',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          type: 'div',
          style: 'width:100%',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          type: 'div',
          style: 'width:100%',
          prop: 'userName'
        },
        {
          label: '充电卡号',
          type: 'div',
          style: 'width:100%',
          prop: 'chargeCardNum'
        },
        {
          label: '充电车辆',
          type: 'div',
          style: 'width:100%',
          prop: 'plateNumber'
        },
        {
          label: '归属企业',
          type: 'div',
          style: 'width:100%',
          prop: 'orgName'
        },
        {
          label: '运营商流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'outStartChargeSeq'
        },
        {
          label: '流量方流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'hlhtStartChargeSeq'
        },
        {
          label: '终端名称',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorName'
        },
        {
          label: '电桩品牌',
          type: 'div',
          style: 'width:100%',
          prop: 'equipBrand'
        },
        {
          label: '电桩型号',
          type: 'div',
          style: 'width:100%',
          prop: 'equipModel'
        },
        {
          label: '电桩功率',
          type: 'div',
          style: 'width:100%',
          prop: 'equipPower'
        },
        {
          label: '电站名称',
          type: 'div',
          style: 'width:100%',
          prop: 'stationName'
        },
        {
          label: '运营商',
          type: 'div',
          style: 'width:100%',
          prop: 'operatorName'
        },
        {
          label: '运营商属性',
          type: 'div',
          style: 'width:100%',
          prop: 'attrValue'
        }
        // {
        //     label: "充电模式",
        //     type: "div",
        //     prop: "chargingType",
        // },
        // {
        //     label: "订单类型",
        //     type: "div",
        //     prop: "orderType",
        // }
      ],
      editformfields: [
        {
          label: '已充电量',
          type: 'div',
          style: 'width:100%',
          prop: 'totalPower'
        },
        {
          label: 'SOC',
          type: 'div',
          style: 'width:100%',
          prop: 'SOC'
        },
        {
          label: '充电状态',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeqStat'
        },
        {
          label: '已充时间',
          type: 'div',
          style: 'width:100%',
          prop: 'hasChargingTime'
        }
      ],
      id: ''
    }
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: token
      }
    }

  },
  mounted() {
    this.getDataDetail()
  },
  beforeMount() {
    this.id = this.$route.query.id
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    getDataDetail() {
      const data = { id: this.id }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/getDataDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          if (resp.equipPower > 0) {
            this.rowdata.equipPower = this.rowdata.equipPower + 'KW'
            this.rowdata.startChargeSeqStat = '充电中'
            // if (resp.startChargeSeqStat == 1) {
            //   this.rowdata.startChargeSeqStat = '启动中'
            // } else if (resp.startChargeSeqStat == 2) {
            //   this.rowdata.startChargeSeqStat = '充电中'
            // } else if (resp.startChargeSeqStat == 3) {
            //   this.rowdata.startChargeSeqStat = '停止中'
            // } else if (resp.startChargeSeqStat == 4) {
            //   this.rowdata.startChargeSeqStat = '已结束'
            // } else if (resp.startChargeSeqStat == 5) {
            //   this.rowdata.startChargeSeqStat = '未知'
            // } else if (resp.startChargeSeqStat == 7) {
            //   this.rowdata.startChargeSeqStat = '启动失败'
            // } else if (resp.startChargeSeqStat == 8) {
            //   this.rowdata.startChargeSeqStat = '停止失败'
            // } else {
            //   this.rowdata.startChargeSeqStat = '--'
            // }
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .orderInfo{
    width: 90%;
    margin:0 auto;
    height:110px;
    display: flex;
    align-items:center;
    justify-content: space-between;
    border-bottom:1px solid #E9E9E9;
    .orderMoney{
      width: 30%;
      color:#999999;
      font-size:12px;
      text-align: center;
      .money{
        color:#1890FF;
        font-size:36px;
      }
    }
  }
  .col-333{
    color:#333333;
  }
  /deep/ .el-form-item {
      .el-form-item__content {
        width: calc(100% - 120px);
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/components/base-info.vue